module.exports = __webpack_public_path__ + "img/solution-icon05.53d4d316.png";